module.exports = __webpack_public_path__ + "img/people_big25.7bde119f.png";